import React, { useState, useEffect, useRef, Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './store'
import { persistStore, persistReducer } from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import './GlobalModules/Utility/Public/css/toastify.css'
import './GlobalModules/Utility/Public/css/theme.css'
import './GlobalModules/Utility/Public/css/common.scss'
import './i18n'
import { ToastContainer } from 'react-toastify'
import './Public/css/mt-modules-scoped.css'

const root = ReactDOM.createRoot(document.getElementById('root'))
const persistor = persistStore(store)
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Suspense fallback={false}>
          <App />
        </Suspense>
      </PersistGate>
    </Provider>
    <ToastContainer />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
